import { TitleAndDescriptionType } from 'features/detailed-comparator/components/DetailedComparator/TitleAndDescription/types';

export const titleAndDescriptionTheme: TitleAndDescriptionType = {
  padding: {
    top: ['16px', '48px'],
    bottom: ['48px', '32px'],
  },
};
